import { Box, Paper, Typography } from "@mui/material";
import React from "react";
import {
    ResponsiveContainer,
    AreaChart,
    Area,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
} from "recharts";

export interface IBurnDownChartProps {
    data: {
        name: string;
        ideal: number;
        actual: number;
    }[];
}

export const BurnDownChart: React.FC<IBurnDownChartProps> = ({ data }) => {
    return (
        <Paper
            elevation={0}
            sx={{
                p: 3,
                borderRadius: 2,
                "background-color": "unset",
            }}
        >
            <Box sx={{ mb: 2 }}>
                <Typography variant="h5" color="text.primary">
                    Gráfico de Burndown
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Mostra o saldo de horas restantes ao longo do tempo,
                    comparando o planejado com o realizado.
                </Typography>
            </Box>

            <Box sx={{ height: 300 }}>
                <ResponsiveContainer width="100%" height="100%">
                    <AreaChart
                        data={data}
                        margin={{ top: 10, right: 30, left: 0, bottom: 5 }}
                    >
                        <defs>
                            <linearGradient
                                id="colorIdeal"
                                x1="0"
                                y1="0"
                                x2="0"
                                y2="1"
                            >
                                <stop
                                    offset="5%"
                                    stopColor="#4caf50"
                                    stopOpacity={0.8}
                                />
                                <stop
                                    offset="95%"
                                    stopColor="#4caf50"
                                    stopOpacity={0.1}
                                />
                            </linearGradient>
                            <linearGradient
                                id="colorActual"
                                x1="0"
                                y1="0"
                                x2="0"
                                y2="1"
                            >
                                <stop
                                    offset="5%"
                                    stopColor="#b39ddb"
                                    stopOpacity={0.8}
                                />
                                <stop
                                    offset="95%"
                                    stopColor="#b39ddb"
                                    stopOpacity={0.1}
                                />
                            </linearGradient>
                        </defs>
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />
                        <XAxis dataKey="name" />
                        <YAxis domain={[0, 100]} />
                        <Tooltip />
                        <Legend />
                        <Area
                            type="monotone"
                            dataKey="ideal"
                            name="Planejado"
                            stroke="#4caf50"
                            fillOpacity={1}
                            fill="url(#colorIdeal)"
                        />
                        <Area
                            type="monotone"
                            dataKey="actual"
                            name="Realizado"
                            stroke="#7e57c2"
                            fillOpacity={1}
                            fill="url(#colorActual)"
                        />
                    </AreaChart>
                </ResponsiveContainer>
            </Box>
        </Paper>
    );
};
